import React, { PropTypes, Component } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import CategoryLink from 'help/components/category_link';
import SearchBox from 'help/containers/search_box';
import { v4 } from 'node-uuid';

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.renderCategory = this.renderCategory.bind(this);
  }

  renderCategory(props) {
    return (
            <li key={v4()} className="sidebar-category-link">
              <CategoryLink {...props}/>
            </li>
          );
  }

  render() {
    const { data, isLoading } = this.props;

    if (!data || isLoading) {
      return <LoadingIndicator />;
    }

    const clientCategories = data.filter(({ user_type }) => (user_type === 'client'));
    const creativeCategories = data.filter(({ user_type }) => (user_type === 'creative'));

    return (<aside className="sidebar">
              <section>
                <SearchBox />
              </section>
              <section>
                <h3>Clients</h3>
                <ul className="category-list">
                  { clientCategories.map(this.renderCategory) }
                </ul>
              </section>
              <section>
                <h3>Creatives</h3>
                <ul className="caetgory-list">
                  { creativeCategories.map(this.renderCategory) }
                </ul>
              </section>
            </aside>);
  }
}

Sidebar.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./help/components/sidebar.jsx